import { ReferralBanner } from '@openeducation/oe-rn-components';
import React from 'react';
import { View } from 'react-native';

import styles from './referral-message.style';
import { useColors } from '../../../hooks';

const ReferralMessage = ({ onActionPress, referralBonusAmount }) => {
  const colors = useColors();

  return (
    <View
      style={[
        styles.bannerContainer,
        {
          backgroundColor: colors.background,
        },
      ]}
    >
      <View style={styles.message}>
        <ReferralBanner
          referralBonusAmount={referralBonusAmount}
          onReferralPress={onActionPress}
        />
      </View>
    </View>
  );
};

export default ReferralMessage;
